import styled from "styled-components";
import { FormGroup } from "~/styles/FormGroup";

export const Group = styled(FormGroup)`
    .inputContainer {
        position: relative;
    }

    svg {
        position: absolute;
        width: 20px;
        right: 10px;
        bottom: 10px;
    }
`;

export const PlaceList = styled.ul`
    position: absolute;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    width: 100%;

    &>li {
        border: 1px solid rgba(0, 0, 0, 0.07);
    }

    &>li:hover {
        background: rgba(0, 0, 0, 0.07);
    }

    &>li:hover button {
        background: rgba(0, 0, 0, 0.07);
        color: black;
    }

    &>li>button {
        width: 100%;
        padding: 5px 10px;
        background: transparent;
        text-align: left;
        cursor: pointer;
        color: gray;
    }

    &>li>button b {
        color: black;
    }

    & .places-license {
        border: none;
        padding: 5px 10px;
        text-align: right;
    }

    & .places-license:hover {
        background: transparent;
    }
`;
